var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:'sampleSetTest' + _vm.sampleSetTest.id,staticClass:"mt-2 hover-cell",on:{"click":function($event){return _vm.$emit('edit', _vm.sampleSetTest)}}},[_c('v-card',[_c('v-card-text',{staticClass:"pa-2"},[_vm._v(" "+_vm._s(_vm.sampleSetTest.name)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }